export default {
  label: {
    title: '¿Agregar componente?',
    description: 'Las reglas de privacidad de las redes sociales y la Ley General de Protección de Datos (LGPD) establecen que los componentes con información de los autores de las publicaciones no deben ser accesibles para usuarios invitados. Dado que su dashboard está compartido, al agregar este componente será ocultado para esos usuarios.',
    button: {
      confirmButton: 'Agregar',
      cancelButton: 'Cancelar',
    },
    message: {
      cancel: 'El componente no se agregó al dashboard.',
    },
  },
};
